(function () {
  "use strict";

  /*
   * Add .as-new-appstle-layout to the wrapper
   * of the new Appstle product layout.
   *
   * The old custom Appstle widget will not be affected.
   */
  var ROOT_SELECTOR = ".as-new-appstle-layout";
  var WIDGET_SELECTOR = ".WIDGET_TYPE_8";

  var QUANTITY_SELECTOR = ".as-price-atc__qty";
  var ATC_PRICE_SELECTOR = ".atc-price";

  var HIDDEN_CLASS = "as-appstle-simple-hidden";
  var INITIALIZED_ATTRIBUTE = "data-as-simple-widget-initialized";

  /*
   * ============================================================
   * STYLES
   * ============================================================
   */

  function installStyles() {
    if (document.getElementById("as-appstle-simple-widget-styles")) {
      return;
    }

    var style = document.createElement("style");

    style.id = "as-appstle-simple-widget-styles";

    style.textContent = `
    .as-appstle-subscription-selected
      .as-price-atc__qty {
      display: none !important;
    }

    .as-appstle-subscription-selected
      .as-price-atc__row {
      grid-template-columns: minmax(0, 1fr) !important;
      width: 100% !important;
    }

    .as-appstle-subscription-selected
      .as-price-atc__buy {
      width: 100% !important;
      max-width: none !important;
      flex: 1 1 100% !important;
    }

    .as-appstle-subscription-selected
      .as-price-atc__buy button {
      width: 100% !important;
      max-width: none !important;
    }
  `;

    document.head.appendChild(style);
  }

  /*
   * ============================================================
   * HELPERS
   * ============================================================
   */

  function isVisible(element) {
    if (!element) return false;

    return Boolean(
      element.offsetWidth ||
      element.offsetHeight ||
      element.getClientRects().length,
    );
  }

  function getSection(widget) {
    return (
      widget.closest(".shopify-section") ||
      widget.closest('[id^="shopify-section-"]') ||
      document
    );
  }

  function getProductForm(section) {
    return (
      section.querySelector('product-form form[action*="/cart/add"]') ||
      section.querySelector('.product-form form[action*="/cart/add"]') ||
      section.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('.product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  /*
   * ============================================================
   * SELECTED PURCHASE OPTION
   * ============================================================
   */

  function getCheckedSellingPlan(widget) {
    return widget.querySelector('input[name="selling_plan"]:checked');
  }
  function isSubscriptionSelected(widget) {
    var selectedOption = widget.querySelector(
      ".appstle_subscription_wrapper_option.appstle-active-option",
    );

    if (!selectedOption) {
      var checkedInput = widget.querySelector(
        '.appstle_subscription_wrapper_option input[name="selling_plan"]:checked',
      );

      if (checkedInput) {
        selectedOption = checkedInput.closest(
          ".appstle_subscription_wrapper_option",
        );
      }
    }

    /*
     * During Appstle rerender there might temporarily
     * be no active or checked option. Keep the last state.
     */
    if (!selectedOption) {
      return widget.dataset.asSubscriptionSelected === "true";
    }

    var subscriptionSelected = Boolean(
      selectedOption.querySelector(".appstle_subscription_radio_wrapper"),
    );

    widget.dataset.asSubscriptionSelected = String(subscriptionSelected);

    return subscriptionSelected;
  }
  /*
   * ============================================================
   * PRICE
   * ============================================================
   */

  function getVisibleMoneyElement(elements) {
    var list = Array.prototype.slice.call(elements || []);

    return (
      list.find(function (element) {
        return (
          isVisible(element) &&
          !element.classList.contains("appstle-sr-only") &&
          !element.closest(".appstle-sr-only")
        );
      }) ||
      list.find(function (element) {
        return (
          !element.classList.contains("appstle-sr-only") &&
          !element.closest(".appstle-sr-only")
        );
      }) ||
      null
    );
  }

  function getSubscriptionPrice(widget) {
    var activeSubscription = widget.querySelector(
      ".appstle_subscription_wrapper_option.appstle-active-option " +
        ".appstle_subscription_amount_wrapper",
    );

    if (!activeSubscription) return "";

    var amount = activeSubscription.querySelector(
      ".appstle_subscription_amount.transcy-money:not([class*='appstle-sr-only'])",
    );

    if (!amount) return "";

    return amount.textContent.replace(/\s+/g, " ").trim();
  }

  function getOneTimePrice(widget, priceElement) {
    var amount = widget.querySelector(
      ".appstle_one_time_price_wrapper " +
        ".appstle_subscription_amount.transcy-money:not([class*='appstle-sr-only'])",
    );

    if (amount) {
      return amount.textContent.replace(/\s+/g, " ").trim();
    }

    return priceElement ? priceElement.dataset.asOneTimePrice || "" : "";
  }

  /*
   * ============================================================
   * QUANTITY
   * ============================================================
   */

  function setQuantityState(form, subscriptionSelected) {
    var quantity = form.querySelector(QUANTITY_SELECTOR);

    if (!quantity) return;

    quantity.classList.toggle(HIDDEN_CLASS, subscriptionSelected);

    quantity.setAttribute(
      "aria-hidden",
      subscriptionSelected ? "true" : "false",
    );

    var quantityInput = quantity.querySelector('input[name="quantity"]');

    /*
     * A subscription must always add one
     * subscription item to the cart.
     */
    if (
      subscriptionSelected &&
      quantityInput &&
      String(quantityInput.value) !== "1"
    ) {
      quantityInput.value = "1";

      quantityInput.dispatchEvent(
        new Event("change", {
          bubbles: true,
        }),
      );
    }
  }

  /*
   * ============================================================
   * PRICE GUARD
   *
   * Other scripts (the old widget's legacy price fallback, the
   * theme's generic variant price sync, Shopify's own form
   * rerender) can independently overwrite .atc-price / the
   * .is-subscription class after we set them, on their own
   * timers, causing a visible flash of the plain variant price.
   *
   * Instead of guessing timings with more setTimeouts, watch
   * these two nodes directly (scoped to this widget's own form)
   * and restore the last confirmed value synchronously whenever
   * anything else changes them. MutationObserver callbacks run
   * as microtasks before the browser paints, so the correction
   * lands before the wrong value is ever shown. Comparing before
   * writing keeps this from looping on its own corrections.
   * ============================================================
   */

  function enforceConfirmedState(widget, priceElement, priceAtc) {
    var confirmedPrice = widget.dataset.asConfirmedPrice;

    if (
      confirmedPrice &&
      priceElement &&
      priceElement.textContent.replace(/\s+/g, " ").trim() !== confirmedPrice
    ) {
      priceElement.textContent = confirmedPrice;
    }

    var confirmedSubscription = widget.dataset.asSubscriptionSelected === "true";

    if (
      priceAtc &&
      priceAtc.classList.contains("is-subscription") !== confirmedSubscription
    ) {
      priceAtc.classList.toggle("is-subscription", confirmedSubscription);
    }
  }

  function guardPriceElements(widget, priceElement, priceAtc) {
    if (priceElement && !priceElement._asPriceGuarded) {
      priceElement._asPriceGuarded = true;

      new MutationObserver(function () {
        enforceConfirmedState(widget, priceElement, priceAtc);
      }).observe(priceElement, {
        characterData: true,
        childList: true,
        subtree: true,
      });
    }

    if (priceAtc && !priceAtc._asClassGuarded) {
      priceAtc._asClassGuarded = true;

      new MutationObserver(function () {
        enforceConfirmedState(widget, priceElement, priceAtc);
      }).observe(priceAtc, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  /*
   * ============================================================
   * UPDATE UI
   * ============================================================
   */

  function updateWidget(widget) {
    if (!document.documentElement.contains(widget)) {
      return;
    }

    var section = getSection(widget);
    var form = getProductForm(section);

    if (!form) return;

    var subscriptionSelected = isSubscriptionSelected(widget);

    /*
     * Keep the state on the section because
     * Shopify can rerender the product form.
     */
    var stateRoot =
      section !== document
        ? section
        : form.closest(".shopify-section") || form.parentElement;

    if (stateRoot) {
      stateRoot.classList.toggle(
        "as-appstle-subscription-selected",
        subscriptionSelected,
      );
    }

    var priceAtc = form.querySelector(".as-price-atc");

    if (priceAtc) {
      priceAtc.classList.toggle("is-subscription", subscriptionSelected);
    }

    setQuantityState(form, subscriptionSelected);

    var priceElement = form.querySelector(ATC_PRICE_SELECTOR);

    guardPriceElements(widget, priceElement, priceAtc);

    if (!priceElement) return;

    if (!priceElement.dataset.asOneTimePrice || !subscriptionSelected) {
      var oneTimePrice = getOneTimePrice(widget, priceElement);

      if (oneTimePrice) {
        priceElement.dataset.asOneTimePrice = oneTimePrice;
      }
    }

    var price = subscriptionSelected
      ? getSubscriptionPrice(widget)
      : getOneTimePrice(widget, priceElement);

    if (price) {
      priceElement.textContent = price;
      widget.dataset.asConfirmedPrice = price;
    }
  }

  /*
   * Appstle updates its markup asynchronously.
   * Run once quickly and once after it finishes rendering.
   */
  var updateTimers = [];

  function scheduleUpdate(widget) {
    updateTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });

    updateTimers = [];

    [0, 100, 300, 700].forEach(function (delay) {
      var timer = window.setTimeout(function () {
        updateWidget(widget);
      }, delay);

      updateTimers.push(timer);
    });
  }

  /*
   * ============================================================
   * INITIALIZE WIDGET
   * ============================================================
   */

  function initializeWidget(widget) {
    if (widget.hasAttribute(INITIALIZED_ATTRIBUTE)) {
      scheduleUpdate(widget);
      return;
    }

    widget.setAttribute(INITIALIZED_ATTRIBUTE, "true");

    widget.addEventListener("change", function () {
      /*
       * Update immediately using the current/cached value,
       * before Shopify has a chance to paint its default price.
       */
      updateWidget(widget);
      scheduleUpdate(widget);
    });

    /*
     * Watch Appstle price, active state
     * and frequency changes.
     */
    var widgetObserver = new MutationObserver(function () {
      /*
       * MutationObserver runs before the browser paints.
       * Replace the temporary Shopify price synchronously.
       */
      updateWidget(widget);
      scheduleUpdate(widget);
    });

    widgetObserver.observe(widget, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    /*
     * Watch Shopify variant changes.
     */
    var section = getSection(widget);
    var form = getProductForm(section);

    if (form) {
      form.addEventListener("variant:change", function () {
        window.setTimeout(function () {
          scheduleUpdate(widget);
        }, 100);
      });
    }

    scheduleUpdate(widget);
  }

  function initializeAllWidgets() {
    document.querySelectorAll(WIDGET_SELECTOR).forEach(initializeWidget);
  }

  /*
   * ============================================================
   * START
   * ============================================================
   */

  function start() {
    installStyles();
    initializeAllWidgets();

    /*
     * Appstle may inject or completely rerender
     * the widget after page load.
     */
    var pageObserver = new MutationObserver(function (mutations) {
      var relevantChange = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) {
            return false;
          }

          return Boolean(
            node.matches?.(
              WIDGET_SELECTOR + ", product-form, .as-price-atc, .atc-price",
            ) ||
            node.querySelector?.(
              WIDGET_SELECTOR + ", product-form, .as-price-atc, .atc-price",
            ),
          );
        });
      });

      if (!relevantChange) return;

      initializeAllWidgets();

      document.querySelectorAll(WIDGET_SELECTOR).forEach(function (widget) {
        /*
         * A new product form might already contain the
         * original variant price. Replace it before paint.
         */
        updateWidget(widget);
        scheduleUpdate(widget);
      });
    });

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true,
    });
  } else {
    start();
  }
})();
